<template>
  <Modal v-model="firstAccess" :closeOnMask="false">
    <Loading text="Loading" :loading="isLoading" />
    <div slot="header">Acesso inicial - Definição tipo de operação Lojas</div>
    <span class="h-tag h-tag-blue info-acesso-inicial">
       <i class="h-icon-info"></i> Por favor, selecione o tipo de operação de cada loja, assim possibilitará a criação de subestruturas para lojas dos tipos "venda direta e híbrida" e suas análises nos gráficos e rankings.
    </span>
    <Row :style="{'width': `${this.modalWidth}`,  'min-height':'200px'}">
     <Cell width="24"  class="empresas-primeiro-acesso">
           <Table stripe border :datas="empresasEdit" :height="250">
              <TableItem className="empresas-primeiro-acesso-i" title="Nome" prop="nomeFantasia" :width="150" />
              <TableItem className="empresas-primeiro-acesso-i" title="Tipode de Operação" prop="name" :width="150">
                 <template  slot-scope="{data}">
                   <Checkbox v-model="data.isRetail">
                          <label>  Varejo</label>
                    </Checkbox>
                    &nbsp;
                    <Checkbox v-model="data.isResale">
                          <label>  Venda Direta</label>
                    </Checkbox>
                 </template>
              </TableItem>
           </Table>
      </Cell>
    </Row>
    <div slot="footer" class="footer-nova-estrutura">
      <button :disabled="isLoading" class="h-btn"  @click="goBack">Voltar</button>
      <button :disabled="isLoading" class="h-btn h-btn-green" color="green" @click="handleUpdateLojas">Definir tipo de operação</button>
    </div>
  </Modal>
</template>
<script>
import { ScreenSize } from '../../mixins/ModalSize';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('empresas');
export default {
  name: 'primeiroAcesso',
  mixins: [ScreenSize],
  data() {
    return {
      dataToEdit: [],
      isOpen: false,
      empresasEdit: [],
      isLoading: false
    };
  },
  props: {
    firstAccess: {
      type: Boolean,
      require: true
    }
  },
  async mounted() {
    try {
      this.$Loading();
      const empresas = await R.Empresa.todas();
      this.empresasEdit = empresas.data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$Loading.close();
    }
  },
  computed: {
    everyIsSelected() {
      if (!this.empresasEdit.length) return false;
      if (this.empresasEdit) {
        const IsUnset = this.empresasEdit.filter(e => e.isResale || e.isRetail);
        return (IsUnset.length === this.totalEmpresas);
      }
      return false;
    },
    modalWidth() {
      return `${this.screen.widthSize < 400
        ? this.screen.widthSize
        : this.screen.widthSize - 200}px`;
    },
    totalEmpresas() {
      return this.empresasEdit ? this.empresasEdit.length : 0;
    }
  },
  methods: {
    ...mapActions(['getEmpresas']),
    goBack() {
      this.$router.push('/');
    },
    async handleUpdateLojas() {
      if (!this.everyIsSelected) {
        this.$Message.info('Por favor, defina o tipo de operação das lojas liastadas');
        return;
      }
      this.isLoading = true;
      const requests = this.empresasEdit.map(e => {
        const { isResale, isRetail } = e;
        const patch = [
          { 'op': 'replace', 'path': 'IsRetail', 'value': isRetail },
          { 'op': 'replace', 'path': 'IsResale', 'value': isResale }
        ];
        return R.Empresa.alterar(patch, e._id);
      });
      Promise.all(requests)
        .then(async () => {
          await this.getEmpresas();
          this.$emit('clearfirstAccess');
        })
        .catch(() => {
          $Message.error(`Houve um errro durante o processo`);
        })
        .finally(async () => {
          this.isLoading = false;
          await this.getEmpresas();
        });
    }
  }
};
</script>

<style>
.form-edit-empresas-inicial{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border: 1px solid #f3f6f8;
  background: #ffffff;
  color: #21201f;
  border-radius: 4px;
  padding: 4px;
  overflow: scroll;
  min-width: 100%;
  margin: 4px 0;
}
.form-edit-empresas-inicial .label-inicial{
font-weight: bold;
font-weight: 12px;
}

.form-edit-empresas-inicial .h-checkbox {
   transform: scale(1.1);
   margin: 0 2px;
}

.checkboxContainer-empresas-inicial{
  display: flex;
  gap: 8px;
  padding: 4px;
  margin-left: auto;
}
.form-edit-empresas p{
  font-weight: bold;
}

.form-edit-empresas input{
  width: 300px;
}
fieldset + fieldset {
margin-top: 8px ;
}

.footer-nova-estrutura{
display: flex;
flex-wrap: wrap;
justify-content: flex-end;
gap: 4px;
}
.btn-nova-estrutura{
margin-right: auto;
}

.main-inicial{
max-height: 300px;
overflow: hidden;
}

.info-acesso-inicial{
  font-size: 12.8px;
  padding: 8px;
  margin: 8px;
}
.empresas-primeiro-acesso-i{
  height: 0px !important;
  padding: 8px !important;
}

@media (max-width: 600px){
 .footer-nova-estrutura{
  flex-direction: column;
 }
 .btn-nova-estrutura{
  margin: 8px auto;
}

}
</style>
